export class Prefecture {
  prefectureId: number = 0
  name: string = ''
  nameKana: string = ''
}
